module.exports = __webpack_public_path__ + "assets/img/tehui.04fb2bfc.png";